export class WidgetSetting {
    FacilityId: string;
    CustomerId: string;
    Facility: string;
    WidgetType: string;
    WidgetName: string;
    ConnectionId: string;
    ShipmentType: string;
    CreatedTime: string;
    LastUpdate: Date;
    OrderPriority: string;
    AppointmentDate: string;
    ShipToCountryCode: string;
    Channel:string;
    Carrier:string;
    ItemNumber: string;
    LithiumWeight: string;
    PassThrus: Array<any>;
    ZoneAisle: string;
    IsPast: string;
    IsCurrent: string;
    IsFuture: string;
    IsLithium: string;
    PickType: string;
    WidgetId: string;
    OldWidgettime: string;
    MonitorType: string;
    CancellationTokenSource : any;
    RefreshInterval: string;
    DataSource: string;
    WaveCode: string;
    StoreCode: string;
    IsBatchWave: string;
    Criteria: string;    
}


// WEBPACK FOOTER //
// ./src/app/models/WidgetSetting.ts